import { createContext } from 'react'

const DataProcessContext = createContext()

export default DataProcessContext
